import type { Dayjs } from 'date';
import { SelectDatePicker } from 'ui';

import { DEFAULT_OPTIONS } from '../../utils/constants';

export const TimeFilter = ({
  onDateChange,
  defaultValue,
  options = DEFAULT_OPTIONS,
}: {
  onDateChange: ({ from, to }: { from: Dayjs; to: Dayjs }) => void;
  defaultValue?: Dayjs;
  options?: { label: string; value: Dayjs }[];
}) => {
  return (
    <SelectDatePicker
      size="small"
      fullWidth={false}
      onChange={onDateChange}
      defaultValue={defaultValue}
      options={options}
      label="Time filter"
      sx={{
        minWidth: 120,
      }}
    />
  );
};
